import { useState, useEffect } from 'react'
import { appFetchTranslateAPI } from '../services/translation'

function UseTranslation(lang) {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState({
    status: false
  })
  useEffect(() => {
    setIsLoading(true)
    const getTranslation = async () => {
      try {
        const result = await appFetchTranslateAPI(lang)
        setIsLoading(false)
        if (!result) return

        const resultObject = result.appFetchTranslate.payload.reduce(
          (accumulator, currentItem) => {
            accumulator[currentItem.key] = currentItem.value
            return accumulator
          },
          {}
        )
        setData(resultObject)
      } catch (error) {
        setIsError({
          status: true,
          error
        })
      }
    }
    if (lang) getTranslation()
  }, [lang])

  return { data, isLoading, isError }
}

export default UseTranslation
